import React from 'react';

import { type EntryPoint, type EntryPointComponent } from 'react-relay';

import { Flex } from '@atlaskit/primitives';
import { type Props } from '@atlassian/entry-point-modal-trigger';

import { DismissMenu } from '../../edition-awareness-dismiss-button';

import { ModalEntryPoint } from './modal-entry-point';
import type { DialogConfig } from './types';

type AnyEntryPoint = EntryPoint<EntryPointComponent<any, any, any, any>, any>;

type DismissibleModalEntryPointProps<T> = Omit<Props<T>, 'children'> & {
	dialogConfig: DialogConfig;
};

export function DismissibleModalEntryPoint<TEntryPoint extends AnyEntryPoint>(
	props: DismissibleModalEntryPointProps<TEntryPoint>,
) {
	return (
		<Flex alignItems="center">
			<ModalEntryPoint {...props} />
			<DismissMenu />
		</Flex>
	);
}
